import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import config from 'utils/config';
import checkIsEditableAsset from 'utils/checkIsEditableAsset';
import { canUserShare, hasMyTeamsAccess } from 'utils/privileges';
import { useAssetViewerContext } from 'screens/AssetViewerUI/hooks/useAssetViewerContext';
import Box from 'components/Box';
import { ActionGrid, ActionGridButton } from 'screens/AssetViewerUI';
import MarkAsDone from './MarkAsDone';
import Like from './Like';
import Share from './Share';
import Save from './Save';
import Download from './Download';
import Stats from './Stats';
import Edit from './Edit';
function Actions(_ref) {
  var autoCompleteEnabled = _ref.autoCompleteEnabled;
  var _useAssetViewerContex = useAssetViewerContext(),
    asset = _useAssetViewerContex.asset,
    downloadUrl = _useAssetViewerContex.downloadUrl;
  if (!asset) return null;
  var parentPlaylist = asset.parentPlaylists.find(function (playlist) {
    return playlist.id === asset.collection_id;
  });
  var showShareButton = canUserShare();
  var showDownloadButton = downloadUrl && asset.download !== 'required';
  var showStatsButton = config.managerReports && asset.insightsEnabled && hasMyTeamsAccess();
  var showEditButton = checkIsEditableAsset({
    contentItem: asset,
    allowEditingDistributedAssets: true
  });
  return /*#__PURE__*/React.createElement(Box, {
    p: "xxs"
  }, /*#__PURE__*/React.createElement(ActionGrid, null, !autoCompleteEnabled && /*#__PURE__*/React.createElement(MarkAsDone, {
    as: ActionGridButton
  }), /*#__PURE__*/React.createElement(Like, {
    as: ActionGridButton
  }), showShareButton && /*#__PURE__*/React.createElement(Share, {
    as: ActionGridButton
  }), /*#__PURE__*/React.createElement(Save, {
    as: ActionGridButton
  }), showDownloadButton && /*#__PURE__*/React.createElement(Download, {
    as: ActionGridButton
  }), showStatsButton && /*#__PURE__*/React.createElement(Stats, {
    as: ActionGridButton
  }), showEditButton && /*#__PURE__*/React.createElement(Edit, {
    as: ActionGridButton,
    parentPlaylistId: asset.collection_id,
    parentPlaylist: parentPlaylist,
    asset: asset
  })));
}
export default Actions;